import moment from "moment";
export function slugify(string) {
    const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœøṕŕßśșțùúüûǘẃẍÿź·/_,:;'
    const b = 'aaaaaaaaceeeeghiiiimnnnooooooprssstuuuuuwxyz------'
    const p = new RegExp(a.split('').join('|'), 'g')
    return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-') // Replace & with ‘and’
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
}

export function fileUploadImage(element) {

    element.target.onerror = null;

    if ( element.target.src.includes('.pdf', -4) ) {

        element.target.src="/images/filetypes/pdf.png"

    } else if ( element.target.src.includes('.zip', -4) ) {

        element.target.src="/images/filetypes/zip.png"

    } else if ( element.target.src.includes('.txt', -4) ) {

        element.target.src="/images/filetypes/txt.png"

    } else if ( element.target.src.includes('.svg', -4) ) {

        element.target.src="/images/filetypes/svg.png"

    } else if ( element.target.src.includes('.avi', -4) ||
                element.target.src.includes('.mov', -4) ||
                element.target.src.includes('.wmv', -4) ||
                element.target.src.includes('.flv', -4) ||
                element.target.src.includes('.ogv', -4) ||
                element.target.src.includes('.webm', -5) ||
                element.target.src.includes('.mpg', -4) ||
                element.target.src.includes('.mpeg', -5) ||
                element.target.src.includes('.m4v', -4) ||
                element.target.src.includes('.svi', -4) ||
                element.target.src.includes('.mp4', -4) ||
                element.target.src.includes('.mkv', -4)
              ) {

        element.target.src="/images/filetypes/video.png"

    } else if ( element.target.src.includes('.pptx', -5) || element.target.src.includes('.ppt', -4) ) {

        element.target.src="/images/filetypes/ppt.png"

    } else if ( element.target.src.includes('.docx', -5) || element.target.src.includes('.doc', -4) ) {

        element.target.src="/images/filetypes/doc.png"

    } else if ( element.target.src.includes('.xlsx', -5) || element.target.src.includes('.xls', -4) ) {

        element.target.src="/images/filetypes/xls.png"

    } else if ( element.target.src.includes('.csv', -4) ) {

        element.target.src="/images/filetypes/csv.png"

    } else if ( element.target.src.includes('.html', -5) ) {

        element.target.src="/images/filetypes/html.png"

    } else {

        element.target.src="/images/filetypes/file.png"

    }

}

export function nl2br (str, is_xhtml) {
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
}

export function formatPriceShown(price) {

    if ( price ) {
        return '€ ' + price.replace('.',',');
    } else {
        return price;
    }

}

export function makeRandomId(length = 7) {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export function isEmpty(str) {
    return (!str || str.length === 0 );
}

export function formatDateTime(dateTime) {

    if (dateTime) {
        let dateTimeAsDate = new Date(dateTime);

        return ('0'+dateTimeAsDate.getDate()).slice(-2) + "-" + ('0'+(parseInt(dateTimeAsDate.getMonth() + 1))).slice(-2) + "-" + dateTimeAsDate.getFullYear() + " " + ('0'+dateTimeAsDate.getHours()).slice(-2) + ":" + ('0'+dateTimeAsDate.getMinutes()).slice(-2);
    }

    return '';

}

export function getDateTime(dateTime) {
    return new moment(dateTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
}

export function getFileTypeImageByMimeType(mime_type) {
    // Returns relative URL for file type icon based on a MIME type (Spatie Media Library style)
    // Examples: application/pdf -> /images/filetypes/pdf.png
    //           video/mp4 -> /images/filetypes/video.png

    const DEFAULT_ICON = "/images/filetypes/file.png";
    if (!mime_type || typeof mime_type !== 'string') {
        return DEFAULT_ICON;
    }

    // Normalize: lowercase and strip parameters after semicolon
    const raw = mime_type.toLowerCase();
    const type = raw.split(';')[0].trim();

    // Group-based handling first
    if (type.startsWith('video/')) {
        return "/images/filetypes/video.png";
    }

    // Exact mappings
    switch (type) {
        case 'application/pdf':
            return "/images/filetypes/pdf.png";
        case 'application/zip':
        case 'application/x-zip-compressed':
            return "/images/filetypes/zip.png";
        case 'text/plain':
            return "/images/filetypes/txt.png";
        case 'image/svg+xml':
            return "/images/filetypes/svg.png";
        case 'text/csv':
        case 'application/csv':
            return "/images/filetypes/csv.png";
        case 'text/html':
            return "/images/filetypes/html.png";
        // PowerPoint
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return "/images/filetypes/ppt.png";
        // Word
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return "/images/filetypes/doc.png";
        // Excel
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return "/images/filetypes/xls.png";
        default:
            return DEFAULT_ICON;
    }
}
